/**
 * Features reducer
 * Source of truth for users with different pricing plans
 */
import { enums } from '@kattana-io/common';
import { RESET_PRICING_PLAN, SET_PRICING_PLAN } from '../actions/features';
import {
  getFeaturesForPricingPlan,
  commonPricingPlan,
} from '../helpers/pricingPlans';

export interface IFeaturesState {
  currentPlan: enums.PricingPlan;
  expiresAt: string;
  features: {
    priceAlerts?: number;
    tokenUnlocks: boolean;
    timeframeExcludes: string[];
    uniswapLiquidity: boolean;
  };
}

export const getDefaultState = (): IFeaturesState => {
  return commonPricingPlan('expired');
};

const defaultState = getDefaultState();

const featuresReducer = (state = defaultState, action: any): IFeaturesState => {
  switch (action.type) {
  case SET_PRICING_PLAN:
    return getFeaturesForPricingPlan(action.payload);
  case RESET_PRICING_PLAN:
    return commonPricingPlan('expired');
  default:
    return state;
  }
};

export default featuresReducer;
